import type { ServiceOrderItem } from '@/services/reparoly/ordersApi';

export type NormalizedOrderItem = ServiceOrderItem & { is_intake?: boolean };

export type IntakeGroup = {
  is_intake: true;
  id: number;
  intake_id: number;
  intake_code: string;
  intake_created_at: string;
  intake_updated_at: string;
  globalStatus?: string | null;
  items: NormalizedOrderItem[];
};

export type OrdersPayloadNode =
  | ServiceOrderItem
  | (Partial<IntakeGroup> & { items?: ServiceOrderItem[] });

export function normalizeOrdersPayload(
  payload: OrdersPayloadNode[],
): { items: NormalizedOrderItem[]; groups: Array<IntakeGroup | NormalizedOrderItem> } {
  const flat: NormalizedOrderItem[] = [];
  const mixed: Array<IntakeGroup | NormalizedOrderItem> = [];

  for (const node of payload as Array<any>) {
    if (node && Array.isArray(node.items)) {
      const items = node.items.map((order: ServiceOrderItem) => {
        const normalized: NormalizedOrderItem = { ...order, is_intake: false };
        flat.push(normalized);
        return normalized;
      });

      mixed.push({
        id: Number(node.intake_id ?? 0),
        is_intake: true,
        intake_id: Number(node.intake_id ?? 0),
        intake_code: node.intake_code ?? '',
        intake_created_at: node.intake_created_at ?? '',
        intake_updated_at: node.intake_updated_at ?? '',
        globalStatus: node.globalStatus ?? null,
        items,
      });
    } else {
      const order = node as ServiceOrderItem;
      const normalized: NormalizedOrderItem = { ...order, is_intake: false };
      flat.push(normalized);
      mixed.push(normalized);
    }
  }

  return { items: flat, groups: mixed };
}
